import { uploadPaymentsData } from '../../_services/payments.service';

export const uploadPaymentsDataEvent = async (bytes, extension, type, date_created) => {
    let res = await uploadPaymentsData(bytes, extension, type, date_created);
    if(! res.ok){
        throw new Error(res.error);
    }     
    return res.data.result;
}